import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, App, Button, Card, Popconfirm, Space, Statistic, Table, Tag, Typography, } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api, apiError } from '@/lib/api';
import { formatDateTime, formatRupiah } from '@/lib/format';
import { useAuthStore } from '@/lib/auth-store';
export function RecognitionPage() {
    const { message } = App.useApp();
    const qc = useQueryClient();
    const hasPerm = useAuthStore((s) => s.hasPerm);
    const q = useQuery({
        queryKey: ['periods'],
        queryFn: async () => (await api.get('/periods')).data,
    });
    const openPeriod = q.data?.find((p) => p.status === 'OPEN');
    const runMut = useMutation({
        mutationFn: async (periodId) => (await api.post(`/abu/recognize/${periodId}`)).data,
        onSuccess: (r) => {
            if (r.contracts_processed === 0) {
                message.info('Tidak ada kontrak yang perlu diakui bulan ini.');
            }
            else {
                message.success(`${r.contracts_processed} kontrak diakui — ${formatRupiah(r.total_recognized)}`);
            }
            qc.invalidateQueries({ queryKey: ['abu-contracts'] });
            qc.invalidateQueries({ queryKey: ['journals'] });
        },
        onError: (e) => message.error(apiError(e)),
    });
    const cols = [
        { title: 'Periode', dataIndex: 'year_month', render: (v) => dayjs(v).format('MMMM YYYY') },
        {
            title: 'Status', dataIndex: 'status', width: 140,
            render: (s) => s === 'OPEN' ? _jsx(Tag, { color: "success", children: "TERBUKA" }) : _jsx(Tag, { color: "volcano", children: "TERTUTUP" }),
        },
        {
            title: 'Ditutup Pada', dataIndex: 'closed_at', width: 200,
            render: (t) => t ? formatDateTime(t) : '—',
        },
        {
            title: 'Aksi', width: 220,
            render: (_, r) => r.status === 'OPEN' && hasPerm('journal:post') ? (_jsx(Popconfirm, { title: "Akui pendapatan bulan ini?", description: "Setiap kontrak abu aktif akan mendapat 1/N bulan dari total kontrak dipindah dari Deferred ke Pendapatan.", onConfirm: () => runMut.mutate(r.id), children: _jsx(Button, { icon: _jsx(PlayCircleOutlined, {}), type: "primary", size: "small", loading: runMut.isPending, children: "Akui Bulan Ini" }) })) : null,
        },
    ];
    return (_jsxs("div", { children: [_jsx(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: _jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Pengakuan Pendapatan Rumah Abu" }) }), _jsx(Alert, { type: "info", showIcon: true, style: { marginBottom: 16 }, message: "Setiap bulan, tekan tombol 'Akui' pada periode terbuka. Backend akan menghitung pengakuan bulanan pro-rata untuk setiap kontrak aktif dan memposting satu jurnal Dr 221.001 / Cr 421.001." }), openPeriod && (_jsx(Card, { style: { marginBottom: 16 }, children: _jsxs(Space, { size: "large", wrap: true, children: [_jsx(Statistic, { title: "Periode Aktif", value: dayjs(openPeriod.year_month).format('MMMM YYYY') }), _jsx(Statistic, { title: "Terakhir dijalankan", value: "Belum dilacak" }), _jsx(Link, { to: "/accounting/journals?source_type=ABU_RECOG", children: _jsx(Button, { children: "Lihat Jurnal Pengakuan" }) })] }) })), _jsx(Card, { children: _jsx(Table, { rowKey: "id", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, pagination: { pageSize: 12 }, size: "middle" }) })] }));
}
